import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import {
  AppInitDetails,
  GET_APP_INIT_DETAILS_MESSAGE_TYPE,
  getAppInitDetails,
} from "api/get-app-init-details";

const QUERY_CACHE_AND_STALE_TIME = 15 * 1000 * 60;

export const useGetAppInitDetails = <TSelect = AppInitDetails>(
  options?: Omit<
    UseQueryOptions<AppInitDetails, Error, TSelect>,
    "queryKey" | "queryFn"
  >
) => {
  const { data, ...query } = useQuery<AppInitDetails, Error, TSelect>({
    queryKey: [GET_APP_INIT_DETAILS_MESSAGE_TYPE],
    queryFn: getAppInitDetails,
    staleTime: QUERY_CACHE_AND_STALE_TIME,
    cacheTime: QUERY_CACHE_AND_STALE_TIME,
    ...options,
  });
  return {
    ...(data as TSelect),
    ...query,
  };
};
